<template>
  <div>
    <p
      v-if="error"
      class="text-danger"
      >{{ errorMsg }}</p
    >
    <!-- Profile Data Card -->
    <b-card class="mb-4">
      <FormulateForm
        class="tu-profile-form"
        v-model="profileData"
        @submit="updateProfile"
      >
        <div class="form-row mb-3">
          <div class="col">
            <FormulateInput
              name="fname"
              type="text"
              label="First Name"
              :placeholder="loading ? '' : 'First name'"
              validation="required"
              validation-name="First Name"
              :disabled="false"
              :disable-errors="loading"
              :input-class="[{ loading: loading }]"
            />
          </div>
          <div class="col">
            <FormulateInput
              name="lname"
              type="text"
              label="Last Name"
              :placeholder="loading ? '' : 'Last name'"
              validation="required"
              validation-name="Last Name"
              :disabled="false"
              :disable-errors="loading"
              :input-class="[{ loading: loading }]"
            />
          </div>
          <div class="col-12 small text-muted mt-1">
            To update your name, go to your overall
            <a
              :href="splUrlMap.user_profile"
              target="_blank"
              >Supplios User Account</a
            >
            page.
          </div>
        </div>

        <FormulateInput
          name="email"
          type="email"
          :disabled="true"
          label="Email Address"
          help="You must contact Supplios Support if you need to change your email address on file."
          :placeholder="loading ? '' : 'you@company.com'"
          :disable-errors="loading"
          :input-class="[{ loading: loading }]"
        />
        <div class="form-row mb-3">
          <div class="col">
            <FormulateInput
              name="job_title"
              type="text"
              label="Job Title"
              :placeholder="loading ? '' : 'Job Title'"
              validation="required"
              validation-name="Job Title"
              :disabled="loading"
              :disable-errors="loading"
              :input-class="[{ loading: loading }]"
            />
          </div>
          <div class="col">
            <FormulateInput
              name="work_location"
              type="text"
              label="Work Location"
              :placeholder="loading ? '' : 'Work Location'"
              help="Plant, office, or other location where you are based"
              :disabled="loading"
              :disable-errors="loading"
              :input-class="[{ loading: loading }]"
            />
          </div>
        </div>
        <FormulateInput
          type="submit"
          :disabled="loading"
        >
          <b-spinner
            small
            v-if="loading"
            class="mr-2"
          ></b-spinner>
          <span>{{ loading ? 'Loading' : 'Update Profile' }}</span>
        </FormulateInput>
      </FormulateForm>
    </b-card>

    <!-- Phone Numbers Card -->
    <b-card>
      <div class="mb-3">
        <TuPhoneNumbers
          ref="phoneNumbersForm"
          :initialPhoneNumbers="phoneNumbers || []"
          :companyId="currentUserInfo.company_id"
          :editMode="!phoneNumbersLoading"
          @changed="handlePhoneNumbersChange($event)"
        />
      </div>
      <b-button
        variant="primary"
        @click="updatePhoneNumbers"
        :disabled="phoneNumbersLoading || !($refs.phoneNumbersForm && $refs.phoneNumbersForm.allNumbersValid)"
      >
        <b-spinner
          small
          v-if="phoneNumbersLoading"
          class="mr-2"
        ></b-spinner>
        <span>{{ phoneNumbersLoading ? 'Saving...' : 'Save Phone Numbers' }}</span>
      </b-button>
    </b-card>
  </div>
</template>

<script>
  import merge from 'lodash/merge';

  import { suppliosApi } from '@/js/api-service';
  import { splUrlMapMixin } from '@/js/custom-vue-mixins';
  import { currentUserInfoMixin } from '@/js/custom-vue-mixins';
  import TuPhoneNumbers from '@/components/tenant_users/TuPhoneNumbers.vue';

  export default {
    name: 'TuPortalProfileUpdate',
    components: { TuPhoneNumbers },
    mixins: [splUrlMapMixin, currentUserInfoMixin],
    data: function () {
      return {
        errorMsg: 'Error',
        error: false,
        loading: true,
        phoneNumbersLoading: false,
        profileData: {},
        phoneNumbers: [],
      };
    },
    mounted: function () {
      this.getProfileData();
      this.getPhoneNumbers();
    },
    methods: {
      handleError(error, message) {
        console.log(message);
        console.log(error);
        this.errorMsg = message;
        this.error = true;
      },
      setLocalData(apiData) {
        // set local profileData object from the structure returned from API
        // API data may be nested if you use nested serializers, so un-nest here
        this.profileData = merge({}, apiData, apiData.tu_profile);
      },
      async getProfileData() {
        this.loading = true;
        try {
          const response = await suppliosApi.portal.getProfileUpdate();
          this.profileData = response.data;
        } catch (err) {
          this.handleError(err, 'Error while getting profile data');
        } finally {
          this.loading = false;
        }
      },
      async getPhoneNumbers() {
        this.phoneNumbersLoading = true;
        try {
          const response = await suppliosApi.phoneNumbers.getPhoneNumbersForTu(this.currentUserInfo.tenant_user_id);
          this.phoneNumbers = response.data;
          this.$refs.phoneNumbersForm.setPhoneNumbers(this.phoneNumbers || []);
        } catch (err) {
          this.handleError(err, 'Error while getting phone numbers');
        } finally {
          this.phoneNumbersLoading = false;
        }
      },
      async updateProfile(data) {
        this.loading = true;
        try {
          const response = await suppliosApi.portal.updateProfileUpdate(data);
          this.profileData = response.data;

          this.$toast.success('Successfully updated your profile.');
        } catch (err) {
          this.handleError(err, 'Error while updating profile data');
        } finally {
          this.loading = false;
        }
      },
      async updatePhoneNumbers() {
        // Use the same endpoint as internal for saving phone numbers
        this.phoneNumbersLoading = true;
        try {
          await suppliosApi.phoneNumbers.updatePhoneNumbersForTu(this.currentUserInfo.tenant_user_id, this.phoneNumbers);
          this.$toast.success('Phone numbers updated.');
          // Refresh phone numbers after update
          await this.getPhoneNumbers();
        } catch (err) {
          this.handleError(err, 'Error while updating phone numbers');
        } finally {
          this.phoneNumbersLoading = false;
        }
      },
      handlePhoneNumbersChange(event) {
        this.phoneNumbers = event;
      },
    },
  };
</script>

<style></style>
